/**
 * Envio de credenciales para login
 *
 * Atributos:
 * - username: ClaveUCC del usuario (mutuamente excluyente con document)
 * - document: DNI del usuario (mutuamente excluyente con username)
 * - password: contrasena del usuario
 */
export interface LoginRequest {
  username?: string;
  document?: string;
  password: string;
}

/**
 * Respuesta de login exitoso sin MFA
 *
 * Atributos:
 * - mfaRequired: siempre false, indica que no se requiere MFA
 * - code: código de autorización OAuth para intercambiar por tokens
 */
export interface SuccessLoginResponse {
  mfaRequired: false;
  code: string;
}

/**
 * Respuesta de login que requiere MFA
 *
 * Atributos:
 * - mfaRequired: siempre true, indica que se requiere MFA
 * - sessionToken: JWT actualizado con auth_token_id para continuar MFA
 * - channels: canales disponibles para verificacion con values ofuscados
 */
export interface MfaLoginResponse {
  mfaRequired: true;
  sessionToken: string;
  channels: import('./channel.interface').Channel[];
}

/** Respuesta de login (puede requerir MFA o devolver sesion directamente) */
export type LoginResponse = SuccessLoginResponse | MfaLoginResponse;

// Type guards
export const isMfaRequired = (r: LoginResponse): r is MfaLoginResponse =>
  'mfaRequired' in r && r.mfaRequired === true;

export const isSuccessLogin = (r: LoginResponse): r is SuccessLoginResponse => 'code' in r;
